import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {addArtImage} from "../../../utils/addItems";
import {RedMessage} from "../../../Components/StyledComponents";
import {setBackgroundState, setLoading} from "../../../store/reducers/modalToggler";
import {getGalleryImageFromPixabay} from "../../../utils/apiHelper";
import LoadingButton from "@mui/lab/LoadingButton";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {showToast} from "../../../store/reducers/notificationSlice";
import {fileUploaderToServer, setCanvasBackground} from "../../../utils/helpers";
import Alert from '@mui/material/Alert';


function GalleryPanel() {
    const {canvas} = useSelector((state) => state.canvas);
    const activeSheet = useSelector((state) => state.activeSheet).sheet;
    const {isLoggedIn} = useSelector((state) => state.loginSlice);
    const {toggleSetBG} = useSelector((state) => state.modalToggle);
    const [btnLoading, setBtnLoading] = useState(false);
    const [noDataMsg, setNoDataMsg] = useState(false);

    const dispatch = useDispatch();

    const [images, setImages] = useState([]);
    const [page, setPage] = useState(1);
    const [query, setQuery] = useState('');

    useEffect(() => {
        if (!isLoggedIn) {
            dispatch(showToast({message: "Please login first", type: "warning"}));
            return;
        }
        getGalleryImageFromPixabay(page, 20, query).then((res) => {
            setImages(res);
        });
    }, []);

    const addImageToCanvas = async (item, id) => {
        dispatch(setLoading(true))
        if (toggleSetBG) {
            setCanvasBackground(canvas, item, dispatch, activeSheet)
            canvas.renderAll()
            dispatch(setBackgroundState(false))
            dispatch(setLoading(false))
        } else {
            const response = await fetch(item);
            const blob = await response.blob();
            const file = new File([blob], `pixabay_${Date.now()}.png`, { type: 'image/png' });

            fileUploaderToServer([file], id, dispatch)
                .then((file)=>{
                    let url = file[0].CompressedUrl ? `${process.env.REACT_APP_cdnURL}/` + file[0].CompressedUrl : item.image
                    addArtImage(url, 100, 100, canvas, id, activeSheet).then(() => {
                dispatch(setLoading(false))
            })
                });
        }
    };

    const loadMoreImages = () => {
        if (isLoggedIn) {
            setBtnLoading(true)
            const newPage = page + 1;
            getGalleryImageFromPixabay(newPage, 20, query).then(async (res) => {
                setImages([...images, ...res]);
                setPage(newPage);
                setBtnLoading(false);
                res.length === 0 && (setNoDataMsg(true));
            })
                .catch(err => {
                    setBtnLoading(false)
                });
        }
    }

    const handleSearch = (e) => {
        setQuery(e.target.value);
        e?.target?.value?.length === 0 && getGalleryImageFromPixabay(1, 20, '').then((res) => {
            setImages(res);
            setPage(1)
        });
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            setPage(1)
            getGalleryImageFromPixabay(page, 20, query).then((res) => {
                setImages(res);
                if (res.length)
                    setNoDataMsg(false);
                else
                    setNoDataMsg(true);
            });
        }
    };

    return (
        <div className="gallery-wrapper">
            {toggleSetBG && <Alert sx={{width: '100%'}} severity="info">Select background image</Alert>}

            <div className="search-section-inner">
                <input
                    type="search"
                    name=""
                    id=""
                    placeholder="Search gallery images"
                    className="search-bar"
                    value={query}
                    onChange={handleSearch}
                    onKeyPress={handleKeyPress}
                />
            </div>
            <div className="images-grid-image-panel gallery-content gnr-m-0 image-grid">
                {
                    images && images.map((item, key) => (
                        <div
                            className={`image-grid__images ${item?.loading ? 'loading-image' : ''}`}
                            key={key}>
                            <>
                                <LazyLoadImage
                                    style={{objectFit: 'cover', cursor: 'pointer'}}
                                    onClick={() => addImageToCanvas(item.largeImageURL, item.id)}
                                    src={item.previewURL}
                                    height={90}
                                    width={90}
                                    alt="imageOb"
                                />
                            </>
                        </div>
                    ))
                }
            </div>
            {noDataMsg && <RedMessage className="">No more data</RedMessage>}
            {images.length > 0 && !noDataMsg &&
            <LoadingButton sx={{mt: 3}}
                           onClick={loadMoreImages}
                           loading={btnLoading}
                           loadingPosition="end"
                           endIcon={<PublishedWithChangesIcon/>}
                           variant="contained"
            >
                <span>Load more</span>
            </LoadingButton>
            }
        </div>
    );
}

export default GalleryPanel;
